import React from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import Header from '../../components/layout/Header';
import AppProvider from '../../providers/AppProvider';
import ViewportProvider from '../../providers/ViewportProvider';
import ThemeProvider from '../../providers/ThemeProvider';
import { endImpersonate } from '../../store/actions/auth';

const PAGES_WITHOUT_HEADER = [
  '/sign-in',
  '/forgot-password',
  '/reset-password',
  '/verify-email',
  '/certification',
];

const AppLayout = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isImpersonating = !!localStorage.getItem('admin_impersonate');

  const handleEndImpersonate = () => {
    dispatch(endImpersonate());
  };

  return (
    <AppProvider>
      <ViewportProvider>
        <ThemeProvider>
          <div className="w-md h-full min-h-screen m-auto flex flex-col bg-lightest-gray overflow-auto sm:justify-between">
            {isImpersonating && (
              <div className="w-full bg-red flex items-center">
                <div className="overflow-hidden flex flex-grow">
                  {new Array(30).fill(1).map((_, id) => (
                    <div className="text-white px-4 italic text-sm" key={id}>
                      Impersonating
                    </div>
                  ))}
                </div>
                <div
                  className="text-white underline cursor-pointer ml-9 mr-4"
                  onClick={handleEndImpersonate}
                >
                  Cancel
                </div>
              </div>
            )}
            {!PAGES_WITHOUT_HEADER.some((path) =>
              location.pathname.includes(path)
            ) &&
              location.pathname !== '/' && <Header />}
            {props.children}
            <footer className="fixed bottom-0 w-full text-center"></footer>
          </div>
        </ThemeProvider>
      </ViewportProvider>
    </AppProvider>
  );
};

export default AppLayout;
